import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/home/user_icon.png';
const _withScopeId = n => (_pushScopeId("data-v-711205de"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "el-dropdown-link"
};
const _hoisted_2 = {
  key: 2,
  class: "rename-body"
};
const _hoisted_3 = {
  class: "name-body"
};
const _hoisted_4 = {
  class: "name-item"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原名称", -1));
const _hoisted_6 = {
  class: "name-item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "现名称", -1));
const _hoisted_8 = {
  class: "dialog-footer"
};
const _hoisted_9 = {
  key: 3,
  class: "rename-body"
};
const _hoisted_10 = {
  class: "share-body"
};
const _hoisted_11 = {
  class: "share-code"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "share-img",
  id: "qrCodeBox"
}, null, -1));
const _hoisted_13 = {
  class: "link-body"
};
const _hoisted_14 = {
  class: "link-title"
};
const _hoisted_15 = {
  key: 4,
  class: "empower-body"
};
const _hoisted_16 = {
  class: "empower-head"
};
const _hoisted_17 = {
  class: "empower-tab"
};
const _hoisted_18 = {
  key: 0,
  class: "empower-content"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "empower-body-head"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "head-title"
}, "分享授权")], -1));
const _hoisted_20 = {
  class: "link-body-get"
};
const _hoisted_21 = {
  class: "content-body"
};
const _hoisted_22 = {
  key: 0,
  class: "number-of-people"
};
const _hoisted_23 = {
  class: "list-number"
};
const _hoisted_24 = {
  class: "item-left"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_26 = {
  class: "item-left-content"
};
const _hoisted_27 = {
  class: "item-01"
};
const _hoisted_28 = {
  class: "item-02"
};
const _hoisted_29 = {
  class: "item-right"
};
const _hoisted_30 = {
  class: "select-body"
};
const _hoisted_31 = {
  class: "el-dropdown-link"
};
const _hoisted_32 = {
  key: 1,
  class: "number-of-people"
};
const _hoisted_33 = {
  class: "list-number"
};
const _hoisted_34 = {
  class: "item-left"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_36 = {
  class: "item-left-content"
};
const _hoisted_37 = {
  class: "item-01"
};
const _hoisted_38 = {
  class: "item-02"
};
const _hoisted_39 = {
  class: "item-right"
};
const _hoisted_40 = {
  class: "select-body"
};
const _hoisted_41 = {
  class: "el-dropdown-link"
};
const _hoisted_42 = {
  key: 1,
  class: "empower-content"
};
const _hoisted_43 = {
  class: "empower-body-head"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "head-title"
}, "协作链接", -1));
const _hoisted_45 = {
  class: "switch-body"
};
const _hoisted_46 = {
  class: "isBegin"
};
const _hoisted_47 = {
  class: "link-body-get"
};
const _hoisted_48 = {
  class: "select-body"
};
const _hoisted_49 = {
  class: "el-dropdown-link"
};
const _hoisted_50 = {
  class: "el-dropdown-link"
};
const _hoisted_51 = {
  key: 0,
  class: "number-of-people"
};
const _hoisted_52 = {
  class: "list-number"
};
const _hoisted_53 = {
  class: "item-left"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_55 = {
  class: "item-left-content"
};
const _hoisted_56 = {
  class: "item-01"
};
const _hoisted_57 = {
  class: "item-02"
};
const _hoisted_58 = {
  class: "item-right"
};
const _hoisted_59 = {
  class: "select-body"
};
const _hoisted_60 = {
  class: "el-dropdown-link"
};
import { ElMessage } from "element-plus";
import { changeRename, createShortLink } from "@/api/exibition";
import { shareListInfo, getUserList, saveUser, saveShareUrl } from "@/api/empower";
import QRCode from "qrcodejs2-fix";
import useClipboard from "vue-clipboard3";
import { renameHall } from "@/api/hall";
import { useConfig } from "@/views/workplace/components/configDialog";
import { dataCollect } from "@/api/me";
import { dateFormat } from "@/utils/dateUtil";
import { userStore } from "@/stores/modules/user";
var Type;
(function (Type) {
  Type[Type["exbition"] = 1] = "exbition";
  Type[Type["hall"] = 2] = "hall";
})(Type || (Type = {}));
export default /*#__PURE__*/_defineComponent({
  __name: 'cardMenu',
  props: {
    objData: {
      default: {}
    },
    commandList: {
      default: props => ["a", "b", "c", "d", "e", "r", "config"]
    }
  },
  emits: ["loginDialog", "clone", "rename", "quit", "command", "refresh", "config", "szrConfig"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      toClipboard
    } = useClipboard();
    const renderMenu = ref(false);
    const router = useRouter();
    const renameVisible = ref(false);
    const shareVisible = ref(false);
    const empowerVisible = ref(false);
    const shareList = ref([]);
    const newShareList = ref([]);
    const copyShareList = ref([]);
    const isSure = ref(false);
    const shareData = ref();
    const loading = ref(false);
    const formData = reactive({
      mobile: ""
    });
    const menuRef = ref();
    const rules = reactive({
      mobile: [{
        required: true,
        message: "请输入手机号码",
        trigger: "blur"
      }, {
        validator: (rules, value, callback) => {
          !/^1(3|4|5|6|7|8|9)\d{9}$/.test(value) ? callback(new Error("请输入正确的手机号码")) : callback();
        },
        trigger: "change"
      }]
    });
    const empowerActiveName = ref("first");
    const {
      objData
    } = toRefs(props);
    const oldName = ref(objData.value.name);
    const newName = ref("");
    const shareUrl = ref(process.env.VUE_APP_BUSINESS_ADDRESS + "?id=" + objData.value.id + "&user=" + userStore().userInfo.userId);
    const type = ref(objData.value.type ? Type[objData.value.type] : Type[1]);
    const handleRender = () => {
      renderMenu.value = true;
      nextTick(() => {
        menuRef.value.handleOpen();
      });
    };
    // 重命名操作
    const renameEvent = () => {
      if (newName.value == "") {
        ElMessage({
          message: "请输入新名称",
          type: "warning"
        });
        return;
      }
      if (type.value == "hall") {
        renameHall({
          id: objData.value.id,
          newName: newName.value
        }, {
          message: "修改成功"
        }).then(() => {
          renameVisible.value = false;
          emit("refresh");
        });
        return;
      }
      let obj = {
        id: objData.value.id,
        name: newName.value
      };
      changeRename(obj).then(res => {
        if (res.status == 200) {
          ElMessage({
            message: "修改成功",
            type: "success"
          });
          renameVisible.value = false;
          emit("refresh");
        } else {
          ElMessage({
            message: res.msg,
            type: "warning"
          });
        }
      });
    };
    // a:重命名 b:授权 c:管理 d:克隆 e:分享
    const handleCommand = command => {
      //直接冒泡command出去
      emit("command", command, props.objData);
      switch (command) {
        case "a":
          newName.value = "";
          renameVisible.value = true;
          break;
        case "e":
          if (!objData.value.previewAddress && !objData.value.previewUrl) {
            ElMessage({
              message: "请到运营端配置模版配置预览地址",
              type: "warning"
            });
            return;
          }
          shareVisible.value = true;
          createShortLink({
            param: JSON.stringify({
              id: objData.value.id,
              user: userStore().userInfo.userId,
              clear: 1
            })
          }).then(({
            data
          }) => {
            shareUrl.value = process.env.VUE_APP_BUSINESS_HOST + "/i/?id=" + data.id;
            nextTick(() => {
              getQrCode();
            });
          });
          break;
        case "b":
          empowerVisible.value = true;
          init();
          nextTick(() => {
            getInfo();
          });
          break;
        case "d":
          emit("clone", props.objData);
          break;
        case "quit":
          emit("quit", props.objData);
          break;
        case "s":
          emit("szrConfig", props.objData);
          break;
        case "rename":
          emit("rename", props.objData);
          break;
        case "config":
          handleConfig();
          emit("config", props.objData);
          break;
        default:
          break;
      }
    };
    // 生成分享二维码
    const getQrCode = () => {
      const qrCodeBox = document.getElementById("qrCodeBox");
      qrCodeBox.innerHTML = "";
      new QRCode(qrCodeBox, {
        text: shareUrl.value,
        width: 120,
        height: 120
      });
      //数据埋点
      dataCollect({
        fieldType: [11]
      });
    };
    // 复制
    const copyEvent = async () => {
      try {
        await toClipboard(shareUrl.value);
        ElMessage({
          message: "复制成功",
          type: "success"
        });
        //数据埋点
        dataCollect({
          fieldType: [11]
        });
      } catch (e) {
        console.error(e);
      }
    };
    // 点击授权获取授权信息接口
    const getInfo = () => {
      let obj = {
        itemId: objData.value.id,
        type: objData.value.type ? objData.value.type : 1 //默认是1:展项    2:展馆,需要传入
      };

      shareListInfo(obj).then(res => {
        if (res.data.shareDetailVO) {
          copyShareList.value = JSON.parse(JSON.stringify(res.data.shareDetailVO));
          shareList.value = res.data.shareDetailVO;
        }
        shareData.value = res.data.shareUrlVO;
        shareData.value.shortUrl = window.location.origin + shareData.value.shortUrl;
      });
    };
    const changeEdit = (command, item) => {
      isSure.value = true;
      shareList.value.map(i => {
        if (i.id == item.id) {
          i.authority = item.authority == 1 ? 2 : 1;
        }
      });
    };
    const changeEdit1 = (command, item) => {
      isSure.value = true;
      newShareList.value.map(i => {
        if (i.mobile == item.mobile) {
          i.authority = item.authority == 1 ? 2 : 1;
        }
      });
    };
    const ruleForm = ref();
    const submitForm = async () => {
      function warnning(text) {
        text && ElMessage({
          message: text,
          type: "warning"
        });
      }
      try {
        const validate = await ruleForm.value?.validateField("mobile");
        if (!validate) return;
        // 重复添加验证
        const hasAdd = i => i.mobile == formData.mobile;
        let isAdd = shareList.value.some(hasAdd);
        let isAdd01 = newShareList.value.some(hasAdd);
        if (isAdd) throw "该成员已被添加";
        if (isAdd01) throw "请勿重复添加";
        // 获取手机号码信息
        getUserList({
          itemId: objData.value.id,
          mobile: formData.mobile
        }).then(res => {
          if (res.status == 200 && res.data) {
            //恢复本地删除
            if (removeTeamUserList.includes(formData.mobile)) {
              shareList.value.push(res.data);
              removeTeamUserList = removeTeamUserList.filter(i => i != formData.mobile);
            } else {
              res.data["authority"] = 1;
              newShareList.value.push(res.data);
            }
          } else {
            throw res.msg;
          }
        });
      } catch (e) {
        typeof e == "string" && warnning(e);
      }
    };
    const localRemoveUser = mobile => {
      newShareList.value.map((i, index) => {
        if (i.mobile == mobile) {
          newShareList.value.splice(index, 1);
        }
      });
    };
    let removeTeamUserList = [];
    const removeUser = mobile => {
      removeTeamUserList.push(mobile);
      shareList.value = shareList.value.filter(i => i.mobile != mobile);
    };
    const inviteEvent = () => {
      let arr = shareList.value.concat(newShareList.value);
      let obj = {
        itemId: objData.value.id,
        shareDetailSaveDtos: arr,
        shareType: type.value == "exbition" ? 1 : 2
      };
      saveUser(obj).then(res => {
        if (res.status == 200) {
          ElMessage({
            message: "更新成员成功",
            type: "success"
          });
          removeTeamUserList = [];
          empowerVisible.value = false;
        }
      });
    };
    const changeLinkEdit = command => {
      shareData.value.authority = command;
      let obj = {
        authority: command
      };
      saveShareUrlEvent(obj);
    };
    const changeTimeEdit = command => {
      shareData.value.validity = command;
      let obj = {
        validity: command
      };
      saveShareUrlEvent(obj);
    };
    const statusEvent = e => {
      let obj = {
        status: e
      };
      saveShareUrlEvent(obj);
    };
    const saveShareUrlEvent = data => {
      data.id = shareData.value.id;
      loading.value = true;
      saveShareUrl(data).then(res => {
        loading.value = false;
      });
    };
    const init = () => {
      shareList.value = [];
      newShareList.value = [];
      shareList.value = [];
      formData.mobile = "";
      empowerActiveName.value = "first";
    };
    // 复制
    const copyLinkEvent = async () => {
      try {
        const phoneFormat = function geTel(tel) {
          return tel.substring(0, 3) + "****" + tel.substr(tel.length - 4);
        };
        const now = new Date();
        const endDate = dateFormat(new Date(now.getFullYear(), now.getMonth(), shareData.value.validity ? now.getDate() + shareData.value.validity : now.getDate()));
        // 授权人: 185****6656
        // 授权项目: 三川田IEDS智慧体验展示系统
        // 链接有效期: 2023.10.1-2023.10.3
        await toClipboard(`授权链接:${shareData.value.shortUrl}
授权人: ${phoneFormat(userStore().userInfo.mobile)}
授权项目: ${objData.value.name}
链接有效期 :${shareData.value.validity == -1 ? "永久有效" : dateFormat(now) + "至" + endDate}
      `);
        ElMessage({
          message: "复制链接成功",
          type: "success"
        });
      } catch (e) {
        console.error(e);
      }
    };
    const {
      showConfig,
      configDialog
    } = useConfig();
    const configId = ref("");
    const handleConfig = () => {
      configId.value = objData.value.id;
      showConfig.value = true;
    };
    return (_ctx, _cache) => {
      const _component_MoreFilled = _resolveComponent("MoreFilled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_Close = _resolveComponent("Close");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_arrow_down = _resolveComponent("arrow-down");
      const _component_el_switch = _resolveComponent("el-switch");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [!_unref(renderMenu) ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        link: "",
        style: {
          "color": "#496eec",
          "display": "block"
        },
        onClick: handleRender
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_MoreFilled)]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 1,
        class: "dropdown-body",
        onCommand: handleCommand,
        trigger: "click",
        ref_key: "menuRef",
        ref: menuRef
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_ctx.commandList.includes('a') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 0,
            command: "a"
          }, {
            default: _withCtx(() => [_createTextVNode("重命名")]),
            _: 1
          })) : _createCommentVNode("", true), _ctx.commandList.includes('b') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 1,
            command: "b"
          }, {
            default: _withCtx(() => [_createTextVNode("授权")]),
            _: 1
          })) : _createCommentVNode("", true), _ctx.commandList.includes('d') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 2,
            command: "d"
          }, {
            default: _withCtx(() => [_createTextVNode("克隆")]),
            _: 1
          })) : _createCommentVNode("", true), _ctx.commandList.includes('r') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 3,
            command: "r"
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 1
          })) : _createCommentVNode("", true), _ctx.commandList.includes('e') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 4,
            command: "e"
          }, {
            default: _withCtx(() => [_createTextVNode("分享")]),
            _: 1
          })) : _createCommentVNode("", true), _ctx.commandList.includes('s') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 5,
            command: "s"
          }, {
            default: _withCtx(() => [_createTextVNode("数字人")]),
            _: 1
          })) : _createCommentVNode("", true), _ctx.commandList.includes('config') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 6,
            command: "config"
          }, {
            default: _withCtx(() => [_createTextVNode("配置")]),
            _: 1
          })) : _createCommentVNode("", true), _ctx.commandList.includes('rename') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 7,
            command: "rename"
          }, {
            default: _withCtx(() => [_createTextVNode("重命名")]),
            _: 1
          })) : _createCommentVNode("", true), _ctx.commandList.includes('quit') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 8,
            command: "quit"
          }, {
            default: _withCtx(() => [_createTextVNode("退出")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          link: "",
          style: {
            "color": "#496eec"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_MoreFilled)]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 512)), _unref(renameVisible) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_dialog, {
        modelValue: _unref(renameVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(renameVisible) ? renameVisible.value = $event : null),
        width: "640",
        title: "重命名"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
          type: "default",
          onClick: _cache[2] || (_cache[2] = $event => renameVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: renameEvent
        }, {
          default: _withCtx(() => [_createTextVNode(" 确定 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_input, {
          modelValue: _unref(oldName),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(oldName) ? oldName.value = $event : null),
          disabled: "",
          autocomplete: "off"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_input, {
          modelValue: _unref(newName),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(newName) ? newName.value = $event : null),
          placeholder: "请输入新名称",
          autocomplete: "off"
        }, null, 8, ["modelValue"])])])]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true), _unref(shareVisible) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_dialog, {
        modelValue: _unref(shareVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(shareVisible) ? shareVisible.value = $event : null),
        width: "640",
        title: "分享"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(_unref(objData).type == 2 ? "展馆二维码" : "展项二维码"), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(_unref(objData).type == 2 ? "展馆链接" : "展项链接"), 1), _createVNode(_component_el_input, {
          modelValue: _unref(shareUrl),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(shareUrl) ? shareUrl.value = $event : null),
          disabled: "",
          autocomplete: "off"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          onClick: copyEvent,
          class: "link-btn",
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode(" 复制 ")]),
          _: 1
        })])])]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true), _unref(empowerVisible) ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_el_dialog, {
        modelValue: _unref(empowerVisible),
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _isRef(empowerVisible) ? empowerVisible.value = $event : null),
        "close-on-click-modal": false,
        "show-close": false,
        width: "550"
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_tabs, {
          modelValue: _unref(empowerActiveName),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(empowerActiveName) ? empowerActiveName.value = $event : null),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "邀请团队",
            name: "first"
          }), _createVNode(_component_el_tab_pane, {
            label: "链接分享",
            name: "second"
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createVNode(_component_el_icon, {
          onClick: _cache[7] || (_cache[7] = $event => empowerVisible.value = false),
          class: "close-btn close-other"
        }, {
          default: _withCtx(() => [_createVNode(_component_Close, {
            class: "icon"
          })]),
          _: 1
        })])]),
        footer: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_button, {
          type: "default",
          onClick: _cache[12] || (_cache[12] = $event => empowerVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _unref(empowerActiveName) == 'first' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          disabled: !_unref(newShareList).length && _unref(copyShareList).length == _unref(shareList).length && !_unref(isSure),
          onClick: inviteEvent
        }, {
          default: _withCtx(() => [_createTextVNode(" 确定 ")]),
          _: 1
        }, 8, ["disabled"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: copyLinkEvent
        }, {
          default: _withCtx(() => [_createTextVNode(" 复制链接 ")]),
          _: 1
        }))])]),
        default: _withCtx(() => [_unref(empowerActiveName) == 'first' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_form, {
          ref_key: "ruleForm",
          ref: ruleForm,
          model: _unref(formData),
          rules: _unref(rules),
          class: "login-ruleForm",
          size: "large",
          "status-icon": "",
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              class: "link-input",
              modelValue: _unref(formData).mobile,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(formData).mobile = $event),
              onKeyup: _withKeys(submitForm, ["enter"]),
              placeholder: "通过手机号来邀请成员加入团队，按回车键结束"
            }, null, 8, ["modelValue", "onKeyup"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]), _createElementVNode("div", _hoisted_21, [_unref(newShareList).length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_22, "待" + _toDisplayString(_unref(newShareList).length) + "人加入管理", 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newShareList), (i, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "number-item"
          }, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(i.name), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(i.mobile), 1)])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: $event => changeEdit1($event, i)
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [i.authority == 2 ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 0,
                command: 1
              }, {
                default: _withCtx(() => [_createTextVNode("可查看")]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 1,
                command: 2
              }, {
                default: _withCtx(() => [_createTextVNode("可编辑")]),
                _: 1
              }))]),
              _: 2
            }, 1024)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_31, [_createTextVNode(_toDisplayString(i.authority == 1 ? "可查看" : "可编辑") + " ", 1), _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_component_arrow_down)]),
              _: 1
            })])]),
            _: 2
          }, 1032, ["onCommand"])]), _createVNode(_component_el_icon, {
            onClick: $event => localRemoveUser(i.mobile),
            class: "close-btn"
          }, {
            default: _withCtx(() => [_createVNode(_component_Close, {
              class: "icon"
            })]),
            _: 2
          }, 1032, ["onClick"])])]);
        }), 128))]), _unref(shareList).length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_32, "已有" + _toDisplayString(_unref(shareList).length) + "人加入管理", 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shareList), (i, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "number-item"
          }, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", _hoisted_36, [_createElementVNode("span", _hoisted_37, _toDisplayString(i.name), 1), _createElementVNode("span", _hoisted_38, _toDisplayString(i.mobile), 1)])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: $event => changeEdit($event, i)
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [i.authority == 2 ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 0,
                command: 1
              }, {
                default: _withCtx(() => [_createTextVNode("可查看")]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 1,
                command: 2
              }, {
                default: _withCtx(() => [_createTextVNode("可编辑")]),
                _: 1
              }))]),
              _: 2
            }, 1024)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_41, [_createTextVNode(_toDisplayString(i.authority == 1 ? "可查看" : "可编辑") + " ", 1), _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_component_arrow_down)]),
              _: 1
            })])]),
            _: 2
          }, 1032, ["onCommand"])]), _createVNode(_component_el_icon, {
            onClick: $event => removeUser(i.mobile),
            class: "close-btn"
          }, {
            default: _withCtx(() => [_createVNode(_component_Close, {
              class: "icon"
            })]),
            _: 2
          }, 1032, ["onClick"])])]);
        }), 128))])])])) : _createCommentVNode("", true), _unref(empowerActiveName) == 'second' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_hoisted_44, _createElementVNode("div", _hoisted_45, [_createElementVNode("span", _hoisted_46, "协作链接" + _toDisplayString(_unref(shareData).status == 1 ? "已开启" : "未开启"), 1), _createVNode(_component_el_switch, {
          onChange: statusEvent,
          modelValue: _unref(shareData).status,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(shareData).status = $event),
          class: "ml-2",
          "active-value": "1",
          "inactive-value": "0",
          style: {
            "--el-switch-on-color": "#13ce66",
            "--el-switch-off-color": "#ff4949"
          }
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_47, [_createVNode(_component_el_input, {
          modelValue: _unref(shareData).shortUrl,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(shareData).shortUrl = $event),
          disabled: "",
          placeholder: "获得链接的人"
        }, {
          append: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: changeLinkEdit
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_unref(shareData).authority == 2 ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 0,
                command: 1
              }, {
                default: _withCtx(() => [_createTextVNode("可查看")]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 1,
                command: 2
              }, {
                default: _withCtx(() => [_createTextVNode("可编辑")]),
                _: 1
              }))]),
              _: 1
            })]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_49, [_createTextVNode(_toDisplayString(_unref(shareData).authority == 1 ? "可查看" : "可编辑") + " ", 1), _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_component_arrow_down)]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: changeTimeEdit
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                command: -1
              }, {
                default: _withCtx(() => [_createTextVNode("永久有效")]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: 7
              }, {
                default: _withCtx(() => [_createTextVNode("七天有效")]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: 3
              }, {
                default: _withCtx(() => [_createTextVNode("三天有效")]),
                _: 1
              })]),
              _: 1
            })]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_50, [_createTextVNode(_toDisplayString(_unref(shareData).validity == -1 ? "永久有效" : _unref(shareData).validity == 3 ? "三天有效" : "七天有效") + " ", 1), _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_component_arrow_down)]),
              _: 1
            })])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["modelValue"])]), _unref(shareList).length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_51, "已有" + _toDisplayString(_unref(shareList).length) + "人加入管理", 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shareList), i => {
          return _openBlock(), _createElementBlock("div", {
            key: i.mobile,
            class: "number-item"
          }, [_createElementVNode("div", _hoisted_53, [_hoisted_54, _createElementVNode("div", _hoisted_55, [_createElementVNode("span", _hoisted_56, _toDisplayString(i.name), 1), _createElementVNode("span", _hoisted_57, _toDisplayString(i.mobile), 1)])]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("span", _hoisted_60, _toDisplayString(i.authority == 1 ? "可查看" : "可编辑"), 1)])])]);
        }), 128))])])), [[_directive_loading, _unref(loading)]]) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true)]), _unref(showConfig) ? (_openBlock(), _createBlock(_unref(configDialog), {
        key: 0,
        show: _unref(showConfig),
        onClose: _cache[14] || (_cache[14] = $event => showConfig.value = false),
        id: _unref(configId)
      }, null, 8, ["show", "id"])) : _createCommentVNode("", true)], 64);
    };
  }
});